import React, { useEffect, useRef } from 'react';
import {
  adminActions,
  adminIsAvaiabailityRequested,
  preSubmitDeleteAvailabilities,
  resetStatus,
  successSelector,
} from '@pharmaplan/common';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import { setDialog } from '../../reducers/dialogReducer';
import useWorkshiftDelete from './useWorkshiftDelete';
import strings from '../../localization';
import { DeactivateModalIcon } from '../../helpers/Constants';
import CancellationDateTime from '../../components/Admin/PharmacyList/ListOfWorkshifts/CancellationDateTime';
import DeactivateDialog from '../../components/Admin/PharmacistList/DeactivateDialog';

const { preSubmitDeleteAvailabilities: preSubmitAction } = adminActions;
const successAction = [preSubmitAction];

interface IDeleteAvailabilityParams {
  availabilityId: string;
  dateTime: string;
}

const useDeleteAvailability = () => {
  const dispatch = useAppDispatch();
  const { showDeleteAvailability, deleteAvailability } = useWorkshiftDelete();

  const apiParams = useRef<IDeleteAvailabilityParams | null>(null);

  const preSubmitDelete = useAppSelector(adminIsAvaiabailityRequested);
  const success = useAppSelector((state) =>
    successSelector(successAction, state));

  const { isAvaiabailityRequested } = preSubmitDelete ?? {};

  const showDeletePreSubmit = (availabilityId: string, dateTime: string) => {
    apiParams.current = { availabilityId, dateTime };

    dispatch(preSubmitDeleteAvailabilities(availabilityId));
  };

  const showDialog = ({
    availabilityId,
    dateTime,
  }: IDeleteAvailabilityParams) => {
    if (isAvaiabailityRequested) {
      dispatch(
        setDialog({
          Component: (
            <DeactivateDialog
              onSubmit={deleteAvailability}
              confirmationMessage={strings.availabilityAlreadyRequested}
              id={availabilityId}
              initialValues={{
                availabilityId,
                notes: '',
              }}
              heading={strings.deleteAvailability}
              iconType={DeactivateModalIcon.warning}
              validator={null}
              name="notes"
              customComponent={
                <CancellationDateTime date={dateTime} />
              }
              primaryButtonLabel={strings.continue}
            />
          ),
          heading: {
            title: '',
          },
          showCloseButton: true,
        }),
      );
    } else {
      showDeleteAvailability(
        availabilityId,
        dateTime,
      );
    }
  };

  useEffect(() => {
    const pendingDelete = apiParams.current;

    if (!success || !pendingDelete) {
      return;
    }

    apiParams.current = null;
    showDialog(pendingDelete);
    dispatch(resetStatus(successAction));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return { showDeletePreSubmit };
};

export default useDeleteAvailability;
